import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner
} from "reactstrap";
import VideoIcon from "../assets/img/custom/VIDEO_VIEW_ICON.png";

import { toast } from "react-toastify";
import {
  createSessionBadge,
  isManagerExist
} from "store/actions/SeasonActions";
import cross from "../assets/img/cross.svg";
import ManagerImage from "../assets/img/custom/MANAGER_HAS_DUTIES_-_-_SEASONAL_SYSTEM_.png";
import firebase from "../config/firebase";
import Paypal from "./Paypal";
import SeasonalPreview from "./SeasonalPreview";
import { getNext5Years } from "context";
import { getSeasonalBadges } from "store/actions/SeasonActions";

const SeasonalBadgeAddModal = ({ toggle, addModal }) => {
  const dispatch = useDispatch();
  const setLoading = false;
  const [ManagerModal, setManagerModal] = useState(false);
  const { user, uid } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.season);
  const [showCustomPriceInput, setShowCustomPriceInput] = useState(false);
  const [showCustomPriceInput2, setShowCustomPriceInput2] = useState(false);
  const [badgePayment, setBadgePayment] = useState(false);
  const [eventPlus, setEventPlus] = useState("");
  const [managerEmail, setManagerEmail] = useState("");
  const [videoURL, setvideoURL] = useState("");
  const [onlineUrlPrice, setonlineUrlPrice] = useState("");
  const [qrCode, setqrCode] = useState("");
  const [qrCodePrice, setqrCodePrice] = useState("");
  const [badgeData, setBadgeData] = useState({
    type: "",
    year: "",
    sport: "",
    listNumber: "",
    typeData1: "",
    typeData2: "",
    typeData3: "",
    sportType: ""
  });
  const ManagerToggle = () => setManagerModal(!ManagerModal);

  const isVideoUrlPairFilled = videoURL !== "" && onlineUrlPrice !== "";
  const isQrCodePairFilled = qrCode !== "" && qrCodePrice !== "";
  const submitBadge = (payload) => {
    let newObj = {
      ...payload,
      ...(isVideoUrlPairFilled && { videoURL, onlineUrlPrice }),
      ...(isQrCodePairFilled && { qrCode, qrCodePrice }),
      ...(eventPlus && { eventPlus }),
      created_at: firebase.firestore.Timestamp.now()
    };
    if (managerEmail === "") {
      setBadgePayment(false);
      dispatch(
        createSessionBadge(uid, newObj, (badgeID) => {
          dispatch(getSeasonalBadges(user?.athleteID, "", () => {}));
          setManagerEmail("");
          clearBadgeStates();
          toggle();
        })
      );
    } else {
      let obj = { ...newObj, managerEmail };
      dispatch(
        isManagerExist(managerEmail, () => {
          setBadgePayment(false);
          dispatch(
            createSessionBadge(uid, obj, (badgeID) => {
              dispatch(getSeasonalBadges(user?.athleteID, "", () => {}));
              setManagerEmail("");
              clearBadgeStates();
              toggle();
            })
          );
        })
      );
    }
  };

  const getPaypalDetail = (details) => {
    const payload = {
      athleteID: user?.athleteID,
      athlete_id: uid,
      ...badgeData,
      amount: details?.purchase_units[0].amount,
      purchaseID: details?.id,
      extra_badge_pay: 0.3
    };
    submitBadge(payload);
  };

  const handleCheckEmail = () => {
    if (isVideoUrlPairFilled || isQrCodePairFilled) {
      if (managerEmail === "") {
        setBadgePayment(true);
      } else {
        dispatch(
          isManagerExist(managerEmail, () => {
            setBadgePayment(true);
          })
        );
      }
    } else {
      toast.error("Please fill at least one of the URL or QR Code fields.");
    }
  };

  const data = {
    year: badgeData.year,
    sport: badgeData.sport,
    type: badgeData.type,
    eventPlus: eventPlus,
    sportType: badgeData.sportType,
    listNumber: badgeData.listNumber,
    typeData1: badgeData.typeData1,
    typeData2: badgeData.typeData2,
    typeData3: badgeData.typeData3,
    qrPrice: qrCodePrice,
    qrCodeImage: qrCode,
    managerRating: false
  };

  const clearBadgeStates = () => {
    setBadgeData({
      type: "",
      year: "",
      sport: "",
      listNumber: "",
      typeData1: "",
      typeData2: "",
      typeData3: "",
      sportType: ""
    });
    setManagerEmail("");
    setvideoURL("");
    setonlineUrlPrice("");
    setqrCode("");
    setqrCodePrice("");
    setEventPlus("");
    setBadgePayment(false);
    setShowCustomPriceInput2(false);
    setShowCustomPriceInput(false);
  };

  useEffect(() => {
    clearBadgeStates();
  }, [addModal]);
  return (
    <>
      <Modal isOpen={addModal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Create seasonal Badge</ModalHeader>
        <h5 className="text-danger text-center">
          First 5 templates free, then $0.30 each to post
        </h5>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              const isBadgeDataValid = Object.keys(badgeData)
                .filter((key) => key !== "type")
                .every((key) => badgeData[key] !== "");

              if (isBadgeDataValid) {
                if (
                  user?.totalSeasonalBadges === undefined ||
                  user?.totalSeasonalBadges < 5
                ) {
                  const payload = {
                    athleteID: user?.athleteID,
                    athlete_id: uid,
                    managerRating: false,
                    ...badgeData
                  };
                  submitBadge(payload);
                } else {
                  handleCheckEmail();
                }
              } else {
                toast.error("Invalid badgeData: Some Fields are empty.");
              }
            }}
          >
            <Row className="d-flex justify-content-center">
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Season Place</Label>
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    value={badgeData?.type}
                    required
                    onChange={(e) =>
                      setBadgeData({ ...badgeData, type: e.target.value })
                    }
                  >
                    <option value="">--Select Type--</option>
                    <option value="Pre-season">Pre-season </option>
                    <option value="Post-season">Post-season </option>
                    <option value="Pre-event">Pre-event</option>
                    <option value="Post-event">Post-event</option>
                    <option value="X">X</option>
                  </Input>
                </FormGroup>
              </Col>
              {(badgeData.type == "Pre-event" ||
                badgeData.type == "Post-event" ||
                badgeData.type == "X") && (
                <Col lg="4" md="6" sm="6">
                  <FormGroup>
                    <Label for="exampleEvent">Event plus</Label>
                    <Input
                      id="exampleEvent"
                      name="select"
                      type="select"
                      value={eventPlus}
                      required
                      onChange={(e) => setEventPlus(e.target.value)}
                    >
                      <option value="">--Select Event--</option>

                      {badgeData.type == "X"
                        ? Array.from({ length: 50 }, (_, index) => (
                            <option
                              key={index + 1}
                              value={`X ${String(index + 1).padStart(2, "0")}`}
                            >
                              X {String(index + 1).padStart(2, "0")}
                            </option>
                          ))
                        : Array.from({ length: 120 }, (_, index) => (
                            <option key={index + 1} value={String(index + 1)}>
                              {index + 1}
                            </option>
                          ))}
                    </Input>
                  </FormGroup>
                </Col>
              )}
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Season</Label>
                  <Input
                    required
                    id="exampleSelect"
                    name="select"
                    type="select"
                    value={badgeData?.year}
                    onChange={(e) =>
                      setBadgeData({ ...badgeData, year: e.target.value })
                    }
                  >
                    <option value="">--Select Season--</option>
                    {getNext5Years().map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Sport</Label>
                  <Input
                    required
                    id="exampleSelect"
                    name="select"
                    type="select"
                    value={badgeData?.sport}
                    onChange={(e) =>
                      setBadgeData({ ...badgeData, sport: e.target.value })
                    }
                  >
                    <option value="">--Select Sport--</option>
                    <option value="FOOTBALL">FOOTBALL</option>
                    <option value="BASKETBALL">BASKETBALL</option>
                    <option value="SOCCER">SOCCER</option>
                    <option value="VOLLEYBALL">VOLLEYBALL</option>
                    <option value="TRACK AND FIELD">TRACK AND FIELD</option>
                    <option value="CROSS COUNTRY">CROSS COUNTRY</option>
                    <option value="BASEBALL">BASEBALL</option>
                    <option value="TENNIS">TENNIS</option>
                    <option value="WRESTLING">WRESTLING</option>
                    <option value="SOFTBALL">SOFTBALL</option>
                    <option value="SWIMMING & DIVING">SWIMMING & DIVING</option>
                    <option value="GOLF">GOLF</option>
                    <option value="COMPETITIVE CHEER/SPIRIT">COMPETITIVE CHEER/SPIRIT</option>
                    <option value="LACROSSE">LACROSSE</option>
                    <option value="FLAG FOOTBALL">FLAG FOOTBALL</option>
                    <option value="BOWLING">BOWLING</option>
                    <option value="FIELD HOCKEY">FIELD HOCKEY</option>
                    <option value="WATER POLO">WATER POLO</option>
                    <option value="ICE HOCKEY">ICE HOCKEY</option>
                    <option value="WEIGHTLIFTING">WEIGHTLIFTING</option>
                    <option value="GYMNASTICS">GYMNASTICS</option>
                    <option value="BEACH VOLLEYBALL">BEACH VOLLEYBALL</option>
                    <option value="SKIING / ALPINE SKIING">SKIING / ALPINE SKIING</option>
                    <option value="BADMINTON">BADMINTON</option>
                    <option value="ESPORTS">ESPORTS</option>
                    <option value="RUGBY">RUGBY</option>
                    <option value="ARCHERY">ARCHERY</option>
                    <option value="FISHING">FISHING</option>
                    <option value="FENCING">FENCING</option>
                    <option value="OTHER">OTHER</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleCategory">Select Event Category</Label>
                  <Input
                    required
                    id="exampleCategory"
                    name="select"
                    type="select"
                    value={badgeData?.sportType}
                    onChange={(e) =>
                      setBadgeData({ ...badgeData, sportType: e.target.value })
                    }
                  >
                    <option value="">--Select Category--</option>
                    <option value="game">Game</option>
                    <option value="meet">Meet</option>
                    <option value="match">Match</option>
                    <option value="cmpet">Cmpet</option>
                    <option value="tourn">Tourn</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Number</Label>
                  <Input
                    required
                    id="exampleSelect"
                    name="select"
                    type="select"
                    value={badgeData?.listNumber}
                    onChange={(e) =>
                      setBadgeData({ ...badgeData, listNumber: e.target.value })
                    }
                  >
                    <option value="">--Select Number--</option>
                    {Array.from({ length: 60 }).map((_, index) => (
                      <option key={index + 200} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleManager">
                    Add manager Email{" "}
                    <i
                      onClick={ManagerToggle}
                      class="fa fa-solid fa-info pointer text-primary mx-2"
                    ></i>{" "}
                  </Label>
                  <Input
                    id="exampleManager"
                    name="select"
                    type="text"
                    placeholder="Add manager Email"
                    readOnly={badgePayment}
                    value={managerEmail}
                    onChange={(e) => setManagerEmail(e.target.value)}
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleType">Vertical text</Label>
                  <Input
                    required
                    id="exampleType"
                    name="select"
                    type="text"
                    placeholder="vertical text"
                    value={badgeData?.typeData1}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        setBadgeData({
                          ...badgeData,
                          typeData1: e.target.value
                        });
                      } else {
                        toast.error(
                          "Type of data should be less than 10 characters"
                        );
                      }
                    }}
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleType">Horizontal text</Label>
                  <Input
                    required
                    id="exampleType"
                    name="select"
                    type="text"
                    placeholder="Horizontal text"
                    value={badgeData?.typeData2}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        setBadgeData({
                          ...badgeData,
                          typeData2: e.target.value
                        });
                      } else {
                        toast.error(
                          "Type of data should be less than 10 characters"
                        );
                      }
                    }}
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleType">Horizontal two text</Label>
                  <Input
                    required
                    id="exampleType"
                    name="select"
                    type="text"
                    placeholder="Horizontal text"
                    value={badgeData?.typeData3}
                    onChange={(e) => {
                      if (e.target.value.length <= 10) {
                        setBadgeData({
                          ...badgeData,
                          typeData3: e.target.value
                        });
                      } else {
                        toast.error(
                          "Type of data should be less than 10 characters"
                        );
                      }
                    }}
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Online Video URL</Label>
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="text"
                    placeholder="Video URL"
                    value={videoURL}
                    onChange={(e) => setvideoURL(e.target.value)}
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Online Video View Price</Label>
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    value={onlineUrlPrice}
                    onChange={(e) => {
                      setonlineUrlPrice(Number(e.target.value));
                      if (e.target.value === "custom") {
                        setShowCustomPriceInput2(true);
                      } else {
                        setShowCustomPriceInput2(false);
                      }
                    }}
                  >
                    <option value="">--Select Price--</option>
                    <option value="6">6</option>
                    <option value="8">8</option>
                    <option value="10">10</option>
                    <option value="custom">Custom Value</option>
                  </Input>
                  {showCustomPriceInput2 && (
                    <Input
                      className="mt-2"
                      type="number"
                      placeholder="Enter Custom Value"
                      value={onlineUrlPrice}
                      onChange={(e) =>
                        setonlineUrlPrice(Number(e.target.value))
                      }
                      min={11}
                      max={500}
                    />
                  )}
                </FormGroup>
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup className="d-flex flex-column">
                  <Label for="exampleSelect">QR Code</Label>
                  {qrCode && (
                    <div className="position-relative">
                      <img
                        src={URL.createObjectURL(qrCode)}
                        alt=""
                        className="mb-3"
                        width={80}
                        height={80}
                      />
                      <img
                        src={cross}
                        width={20}
                        alt=""
                        className="position-absolute"
                        style={{
                          top: "-11%",
                          left: "39%",
                          cursor: "pointer"
                        }}
                        onClick={() => setqrCode("")}
                      />
                    </div>
                  )}
                  {!qrCode && (
                    <Input
                      id="exampleSelect"
                      name="select"
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setqrCode(file);
                        }
                      }}
                    ></Input>
                  )}
                </FormGroup>{" "}
              </Col>
              <Col lg="4" md="6" sm="6">
                <FormGroup>
                  <Label for="exampleSelect">Online Badge Card Price</Label>
                  <Input
                    id="exampleSelect"
                    name="select"
                    type="select"
                    value={qrCodePrice}
                    onChange={(e) => {
                      setqrCodePrice(Number(e.target.value));
                      if (e.target.value === "custom") {
                        setShowCustomPriceInput(true);
                      } else {
                        setShowCustomPriceInput(false);
                      }
                    }}
                  >
                    <option value="">--Select Price--</option>
                    <option value="8">8</option>
                    <option value="16">16</option>
                    <option value="32">32</option>
                    <option value="custom">Custom Value</option>
                  </Input>
                  {showCustomPriceInput && (
                    <Input
                      className="mt-2"
                      type="number"
                      placeholder="Enter Custom Value"
                      value={qrCodePrice}
                      onChange={(e) => setqrCodePrice(Number(e.target.value))}
                      min={17}
                      max={1000}
                    />
                  )}
                </FormGroup>{" "}
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Button color="primary" type="submit" disabled={loading}>
                {loading ? (
                  <Spinner size="sm" className="mx-4" />
                ) : (
                  "Create Badge"
                )}
              </Button>
            </Row>
            {badgePayment && (
              <>
                <h5 className="text-center text-danger my-2">
                  You have reached your limit of free posts, pay $0.30 to
                  continue
                </h5>
                <div>
                  <Paypal
                    price={0.3}
                    getPaypalDetail={getPaypalDetail}
                    setLoading={setLoading}
                  />
                </div>
              </>
            )}
          </Form>
          <Row className="d-flex justify-content-center">
            <Card className="col-lg-6 col-md-8 col-sm-8 mb-3 mt-5 mx-2">
              <SeasonalPreview data={data} />
            </Card>
            <Card className="col-lg-4 sol-md-12 sol-sm-8 mb-3 mt-5 mx-2 text-center">
              <h4 className="m-0 p-0">
                {badgeData?.type === "X"
                  ? eventPlus?.substring(0, 4)
                  : badgeData?.type?.substring(0, 4)}{" "}
                {badgeData.sportType} {badgeData.listNumber}
              </h4>
              <a className="text-white  " href={videoURL} target="_blank">
                <img src={VideoIcon} className="image-flui" />
              </a>
              <h4 className="mb-0">
                {user?.first_name + " " + user?.last_name} {user.athleteID}
                <h4>{badgeData.sport}</h4>
              </h4>{" "}
              <h3 className="m-0 p-0">{onlineUrlPrice}</h3>
            </Card>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={ManagerModal} toggle={ManagerToggle} size="lg">
        <Container className="text-center mx-auto">
          <img src={ManagerImage} alt="image" className="img-fluid mx-auto" />
        </Container>
        <div className="d-flex justify-content-end align-items-end mb-2 mr-4">
          <Button color="primary" onClick={ManagerToggle}>
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default SeasonalBadgeAddModal;
